
import { format } from '../formatDate';
namespace DBBLib {
    let debug = require('./debug');
    let Profile = require('./profileAndSettings');
    let Simple = require('./simple');
    if (format == null && debug == null && Profile == null && Simple == null)
        console.error('WTF?');
}

class DxElement<T> {
    protected selector: string;
    private mainFunc: string;
    private _configuration: any;

    constructor(selector: string, mainFunc: string, config: any) {
        this.selector = selector;
        this.mainFunc = mainFunc;
        this._configuration = config;
    }

    get Element(): JQuery {
        return $(this.selector);
    }

    get Instance(): T {
        return this.Element[this.mainFunc]('instance');
    }


}
module.exports = {
    DxElement
}